import {ChangeEvent} from 'react'
import '../styles/Forms.scss'
import DescriptionIcon from '@mui/icons-material/Description'
import Button from '@mui/material/Button'

const shortenFileName = (selectedFileName: string) => {
    const FILE_NAME_SIZE = 30
    if (selectedFileName.length <= FILE_NAME_SIZE) {
        return selectedFileName
    } else {
        return selectedFileName.substring(0, FILE_NAME_SIZE) + '...'
    }
}

const UploadFileLoadingButton = ({
                                     selectedFileName,
                                     parseFile,
                                     className = '',
                                     name = 'upload-file',
                                     id = 'upload-file',
                                     variant = 'contained',
                                     acceptedFileType
                                 }:
                                 {
                                     selectedFileName?: string,
                                     name?: string, id?: string, className?: string,
                                     variant?: 'outlined' | 'contained',
                                     acceptedFileType?: string,
                                     parseFile: (event: ChangeEvent<HTMLInputElement>) => void
                                 }) => {
    return <Button data-testid="file-upload-btn" component="label" variant={variant} color="primary"
                   className={className}
                   endIcon={!selectedFileName && <DescriptionIcon/>}>
        {selectedFileName ? shortenFileName(selectedFileName) : 'Add File'}
        <input name={name} id={id} onChange={parseFile} hidden type="file"
               accept={acceptedFileType}/>
    </Button>


}

export default UploadFileLoadingButton


